// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'hci' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di hci.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/hci.sr-Cyrl-RS.meta.json.
import type { enUS } from './hci'

export const srCyrlRS: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph кластери',
      createButton: 'Креирај Ceph кластер',
      emptyTitle: 'Још ниједан управљани Ceph кластер',
      emptyBody: 'TVirt deployuje и поседује Ceph на чланским чворовима, хиперконвергентно са VM оптерећењем. Креирајте кластер: први монитор и његов manager рађају се аутоматски на изабраном контролном чвору — затим га проширите додатним мониторима и OSD уређајима.',
      pageTitle: 'Ceph кластери',
      colState: 'Стање',
      colMembers: 'Чланови',
      colSize: 'Величина',
      colVersion: 'Ceph верзија',
      sizeCell: 'искоришћено {used} GiB од укупно {total} GiB',
      phase: {
        'not-deployed': 'Није deployovan',
        deploying: 'Deploy у току',
        healthy: 'Здрав',
        degraded: 'Деградиран',
        error: 'Грешка',
        destroying: 'Уништавање у току',
        destroyed: 'Уништен'
      },
      health: {
        HEALTH_OK: 'Здрав (HEALTH_OK)',
        HEALTH_WARN: 'Са упозорењима (HEALTH_WARN)',
        HEALTH_ERR: 'Са грешком (HEALTH_ERR)',
        unknown: 'Још није посматрано',
        observedAt: 'посматрано {time}'
      },
      create: {
        title: 'Креирајте Ceph кластер',
        info: 'Када се креира нови Ceph кластер, бира се први чвор на који ће бити инсталиране улоге MON и MGR. Такође треба навести коју подмрежу користити за Ceph саобраћај: public подмрежа се користи за општи мрежни саобраћај, док се кластер подмрежа користи за интерне реплике између OSD-ова; различите подмреже нису строго неопходне.',
        controlNode: 'Контролни чвор',
        controlNodeHint: 'Члански чвор на ком се рађају први MON + MGR.',
        publicSubnet: 'Public подмрежа',
        publicSubnetHint: 'Subnet регистрована у IPAM-у — Cephova public_network. Непроменљива после креирања.',
        clusterSubnet: 'Кластер подмрежа',
        clusterSubnetHint: 'Subnet регистрована у IPAM-у — Cephova cluster_network (репликација/backfill).',
        noSubnets: 'Ниједна Subnet није регистрована — прво их креирајте у IPAM-у',
        sameSubnet: 'Иста подмрежа за public и кластер саобраћај',
        sameSubnetHint: 'Означено = кластер мрежа (репликација/backfill) поклапа се са public мрежом. Неозначено = изаберите за њу сопствену подмрежу И адресу контролног чвора унутар ње.',
        controlAddress: 'Адреса контролног чвора',
        controlAddressHint: 'Адреса коју IPAM познаје за чвор унутар public подмреже.',
        controlClusterAddress: 'Кластер адреса контролног чвора',
        controlClusterAddressHint: 'Адреса коју IPAM познаје за чвор унутар кластер подмреже.',
        noAddresses: 'IPAM не познаје ниједну адресу овог чвора унутар изабране подмреже',
        started: 'Кластер креиран — bootstrap се наставља као макрозадатак; фаза се сама ажурира',
        error: 'Кластер је одбијен'
      },
      detail: {
        actions: 'Доступне акције',
        tabOverview: 'Преглед',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Poolovi',
        tabObjects: 'Објекти',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Напредно',
        phase: 'Фаза',
        checksTitle: 'Активне провере здравља',
        noChecks: 'Ниједна активна провера здравља',
        checkMuted: 'утишан',
        summaryPools: 'Poolovi',
        summaryFilesystems: 'Filesystemi',
        nodesCard: 'Чворови',
        monHint: 'MGR ради колоциран уз сваки MON. Три MON-а су препоручени кворум; лабораторијски кластер креће са једним. OSD-ови и MDS-ови живе у својим табовима.',
        monHintSplit: 'MON и MGR су раздвојени на овом кластеру (Напредно): свака улога је сопствено чланство по чвору. Три MON-а су препоручени кворум; бар један MGR мора постојати.',
        noMons: 'Ниједан монитор није декларисан',
        addNode: 'Додај чвор',
        removeNode: 'Уклони чвор',
        removeNodeFrom: 'Уклони чвор {node} (његов MON и колоцирани MGR)',
        roleMon: 'Улога MON',
        roleMgr: 'Улога MGR',
        roleNa: 'N/A',
        roleNotObserved: 'још није посматрана',
        monInQuorum: 'у кворуму',
        monOutQuorum: 'ван кворума',
        mgrActive: 'активан',
        mgrStandby: 'standby',
        addRoleMon: 'Додај улогу MON',
        removeRoleMon: 'Уклони улогу MON',
        addRoleMgr: 'Додај улогу MGR',
        removeRoleMgr: 'Уклони улогу MGR',
        restartMon: 'Рестартуј MON сервис',
        restartMgr: 'Рестартуј MGR сервис',
        addMon: 'Додај MON',
        removeMon: 'Уклони MON',
        removeMonFrom: 'Уклони улогу MON са чвора {node}',
        addMgr: 'Додај MGR',
        removeMgr: 'Уклони MGR',
        removeMgrFrom: 'Уклони улогу MGR са чвора {node}',
        addMds: 'Додај MDS',
        removeMds: 'Уклони MDS',
        removeMdsFrom: 'Уклони улогу MDS са чвора {node}',
        mdsSection: 'Metadata сервери (MDS)',
        noMds: 'Ниједан MDS није декларисан — filesystemu је прво потребан један',
        mdsHint: 'Чланство MDS-ова је сопствено од првог дана: кластер без CephFS-а не декларише ниједан, један активан плус један standby добро служе filesystem. Ceph бира активне и standby међу декларисаним демонима.',
        mdsActiveFor: 'активан — {fs}',
        mdsNotObserved: 'још није посматран',
        lastMdsGuard: 'Последњи MDS се не може уклонити док постоји filesystem — прво уклоните filesysteme',
        lastMonGuard: 'Последњи MON се не може уклонити — уништавање кластера је једини излаз',
        lastMgrGuard: 'Последњи MGR се не може уклонити — управљани кластер никада не ради без managera',
        registerDevice: 'Додај OSD',
        unregisterDevice: 'Дерегиструј',
        activeDeviceGuard: 'Активан OSD — излази кроз животни циклус OSD-а, не кроз регистар',
        colNode: 'Чвор',
        devicePhase: { registered: 'Регистрован', active: 'Активан' },
        health: 'Здравље',
        state: 'Стање',
        fsid: 'fsid',
        fsidPending: 'одсутан — поновите bootstrap',
        version: 'Ceph верзија',
        publicNetwork: 'Public мрежа',
        clusterNetwork: 'Кластер мрежа',
        clusterNetworkCollapsed: '= public',
        noActions: 'Ниједна акција није доступна у овој фази',
        destroyedNote: 'Кластер уништен — ред се убрзо аутоматски уклања'
      },
      overview: {
        services: 'Сервиси',
        ok: 'здраво',
        warning: 'warning',
        down: 'down',
        pgTitle: 'Стања PG-ова',
        pgTotal: 'укупно PG-ова: {n}',
        capacityTitle: 'Простор',
        ioTitle: 'Тренутни I/O',
        ioReadBw: 'Проток при читању',
        ioWriteBw: 'Проток при писању',
        ioReadIops: 'IOPS при читању',
        ioWriteIops: 'IOPS при писању',
        notObserved: 'још није посматрано'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Стање',
        colSize: 'Величина',
        colPgs: 'PG',
        empty: 'Још нема OSD-ова — додајте један из декларисаног диска за податке',
        markIn: 'Означи IN',
        markOut: 'Означи OUT',
        scrub: 'Покрени scrub',
        deepScrub: 'Покрени дубоки scrub',
        restart: 'Рестартуј сервис',
        details: 'Детаљи',
        actionGuard: 'Само на активном OSD-у deployovanog кластера',
        inTitle: 'Означите OSD IN',
        inBody: 'osd.{id} се враћа у расподелу података (ceph osd in): Ceph ребалансира податке назад на њега.',
        outTitle: 'Означите OSD OUT',
        outBody: 'osd.{id} напушта расподелу података (ceph osd out): његови подаци се ребалансирају другде и редунданса је СМАЊЕНА док backfill траје. Реверзибилно у сваком тренутку помоћу Означи IN.',
        scrubTitle: 'Закажите scrub',
        scrubBody: 'Заказује се scrub за osd.{id}: mon га ставља у ред чекања, а стања PG-ова у наредним sweepovima показују исход.',
        deepScrubTitle: 'Закажите дубоки scrub',
        deepScrubBody: 'Заказује се дубоки scrub за osd.{id}: варијанта која верификује бајтове — тежа за I/O, иста механика.',
        restartTitle: 'Рестартујте OSD сервис',
        restartBody: 'osd.{id} се зауставља и поново покреће кроз надзор workera на његовом чвору.',
        started: 'Акција покренута — осматрање се само ажурира',
        error: 'OSD акција је одбијена'
      },
      osdDetail: {
        title: 'Детаљи OSD-а',
        tabGeneral: 'Опште',
        tabNetwork: 'Мрежа',
        tabDevices: 'Уређаји',
        version: 'Верзија',
        hostname: 'Hostname',
        dataPath: 'Путања OSD података',
        objectStore: 'OSD object store',
        encrypted: 'Шифрован',
        yes: 'Да',
        no: 'Не',
        memory: 'Употреба меморије (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front адреса (клијент & монитор)',
        hbFront: 'Heartbeat front адреса',
        back: 'Back адреса (OSD)',
        hbBack: 'Heartbeat back адреса',
        colDevice: 'Device',
        colType: 'Тип',
        colPhysical: 'Физички device',
        colSize: 'Величина',
        volumeTitle: 'Детаљи волумена',
        creationTime: 'Датум креирања',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Ниједан device није посматран за овај OSD'
      },
      restart: {
        title: 'Рестартујте сервис',
        monBody: 'Демон MON на чвору {node} се зауставља и поново покреће кроз надзор workera.',
        mgrBody: 'Демон MGR на чвору {node} се зауставља и поново покреће кроз надзор workera.',
        started: 'Restart покренут — осматрање се само ажурира',
        error: 'Restart је одбијен'
      },
      encryptionMode: {
        alwaysOn: 'Увек омогућено (dmcrypt)',
        alwaysOff: 'Увек онемогућено',
        perOsd: 'Избор по сваком OSD-у',
        section: 'Шифровање OSD-а at rest',
        title: 'Промените режим шифровања OSD-а',
        hint: 'Како се припремају НОВИ OSD-ови. Постојећи OSD-ови задржавају своје стање по диску: да бисте га променили, уклоните OSD и поново га креирајте.',
        body: 'Режим постаје „{mode}“ и важи САМО за НОВЕ OSD-ове: сваки постојећи OSD задржава своје тренутно стање шифровања.',
        apply: 'Промени режим',
        error: 'Промена режима је одбијена'
      },
      pin: {
        address: 'Public адреса (опциони pin)',
        clusterAddress: 'Кластер адреса (опциони pin)',
        autoPlaceholder: 'аутоматски унутар подмреже {cidr}',
        hint: 'Адресирање по демону: празно = Ceph се сам везује унутар декларисане мреже; постављено = ова инстанца демона је пинована на адресу у својој conf секцији.'
      },
      addMon: {
        title: 'Додајте чвор',
        node: 'Чвор',
        address: 'Public адреса',
        addressHint: 'Адресе чвора које IPAM познаје унутар public подмреже — аутоматски када постојећа декларација покрива чвор.',
        clusterAddress: 'Кластер адреса',
        clusterAddressHint: 'Обавезно: кластер подмрежа је одвојена и чвор на њој још није декларисан.',
        noAddresses: 'IPAM не познаје ниједну адресу овог чвора унутар подмреже',
        error: 'Додавање mona је одбијено'
      },
      removeMon: {
        title: 'Уклоните MON',
        body: 'MON и његов колоцирани MGR напуштају чвор {node}. На deployovanom кластеру демони се заустављају и уклањају из кворума.',
        error: 'Уклањање MON-а је одбијено'
      },
      addMgr: {
        title: 'Додајте MGR',
        node: 'Чвор',
        hint: 'Напредно (раздвојени MON/MGR): standalone manager рађа се на изабраном чланском чвору задатком везаним за чвор. Cephov сопствени active/standby избор сам бира активни MGR.',
        error: 'Додавање MGR-а је одбијено'
      },
      removeMgr: {
        title: 'Уклоните MGR',
        body: 'Standalone MGR напушта чвор {node}. На deployovanom кластеру демон се зауставља и његово стање уклања; MON тог чвора (ако постоји) остаје нетакнут.',
        error: 'Уклањање MGR-а је одбијено'
      },
      addMds: {
        title: 'Додајте MDS',
        node: 'Чвор',
        hint: 'Metadata сервер CephFS-а: рађа се на изабраном чланском чвору задатком везаним за чвор, под надзором workera као MON и MGR. Ceph сам бира активне и standby — један активан плус један standby добро служе filesystem.',
        error: 'Додавање MDS-а је одбијено'
      },
      removeMds: {
        title: 'Уклоните MDS',
        body: 'MDS напушта чвор {node}. На deployovanom кластеру демон се зауставља и његово стање уклања; API одбија последњи MDS док га неки filesystem још треба.',
        error: 'Уклањање MDS-а је одбијено'
      },
      split: {
        title: 'Раздвојени MON/MGR',
        label: 'Дозволи MON и MGR на раздвојеним чворовима',
        hint: 'Искључено (подразумевано) = ратификовани стандард: MGR ради колоциран уз сваки MON, једно једино чланство. Укључено = чланство MGR-ова постаје сопствено, управљано акцијама Додај/Уклони MGR у табу Управљачки чворови.',
        enable: 'Укључи',
        disable: 'Искључи',
        enableBody: 'Чланство MGR-ова постаје независно од MON-ова, иницијализовано из тренутне колокације. Акције Додај/Уклони MGR активирају се у табу Управљачки чворови. Ово опушта подразумевано понашање платформе — задржите га само ако знате зашто вам треба.',
        disableBody: 'Повратак на стандардну колокацију: MGR уз сваки MON, једно једино чланство. Легално само док се чланство MGR-ова већ поклапа са MON-овима — прво га поравнајте акцијама Додај/Уклони MGR, или ће API одбити.',
        error: 'Измена је одбијена'
      },
      rawEditor: {
        title: 'Сирови CRUSH editor',
        label: 'Прикажи сирови crushmap editor у табу CRUSH',
        hint: 'Искључено (подразумевано) = вођена површина правила је стандардни алат. Укључено = таб CRUSH приказује и декомпајлирани crushmap као текст који се може уређивати. Чување увек захтева sudo, име кластера као потврду, и пролази кроз crushtool compile + тест ПРЕ него што стигне до кластера.'
      },
      osdFlags: {
        section: 'Глобални OSD flagovi',
        title: 'Override OSD flagova',
        notObserved: 'још нису посматрани',
        standardFlowsHint: 'Стандардни токови платформе сами управљају овим flagovima у нормалним случајевима (одржавање чвора поставља циљани noout, замена диска иде кроз животни циклус OSD-а). Ова секција је ручни override за оператера који зна шта ради.',
        notDeployedGuard: 'OSD flagovi постоје само на deployovanom кластеру',
        set: 'Постави flag',
        unset: 'Уклони flag',
        setBody: 'Глобални flag {flag} биће ПОСТАВЉЕН на осдмапу. Остаје док се експлицитно не уклони — заборављен flag деградира самоопоравак кластера.',
        unsetBody: 'Глобални flag {flag} биће УКЛОЊЕН са осдмапа.',
        error: 'Промена flaga је одбијена',
        flag: {
          noout: 'Ниједан OSD се не означава out из расподеле података — нема ребаланса при губитку демона',
          norebalance: 'Ребаланс података је суспендован',
          nobackfill: 'Backfill је суспендован',
          norecover: 'Recovery је суспендован',
          pause: 'САВ клијентски I/O је паузиран (читања и писања)',
          noin: 'OSD-ови који се подижу не означавају се in аутоматски',
          nodown: 'Недоступни OSD-ови се не означавају down — маскира стварне отказе'
        }
      },
      pools: {
        section: 'Poolovi',
        create: 'Креирај pool',
        createGuard: 'Poolovi постоје само на deployovanom кластеру',
        notObserved: 'Још нема осматрања poolova — mon sweep извештава овде',
        empty: 'Ниједан pool на кластеру',
        colName: 'Име',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Апликација',
        colRule: 'CRUSH правило',
        colUsage: 'Искоришћеност',
        observedAtLabel: 'Посматрано',
        objects: 'објеката: {n}',
        inUseBy: 'користи га {name}',
        internalGuard: 'Интерни Cephov pool — платформа га никада не брише',
        delete: 'Обриши pool',
        deleteGuard: 'Конзумира га storage {name} — прво обришите storage',
        hint: 'Само репликовани poolovi (erasure coding је ван scopea v1). Репликација живи у Cephu: ова табела је посматрана истина из mon sweepa.',
        createTitle: 'Креирајте pool',
        createHint: 'Pool се рађа на кластеру са траженом репликацијом и укљученом rbd апликацијом — посао обавља задатак на MON чвору. Укључите „Предложи као storage“ да га одмах конзумирате истим гестом.',
        name: 'Име poola',
        nameHint: 'DNS-safe (мала слова, цифре, цртице).',
        size: 'Реплике (size)',
        sizeHint: 'Копије сваког објекта. Подразумевано 3.',
        minSize: 'Минималне реплике (min_size)',
        minSizeHint: 'Минималне копије за послуживање I/O — прати size − 1 док га не измените.',
        createError: 'Креирање poola је одбијено',
        deleteTitle: 'Обришите pool',
        deleteBody: 'Pool {pool} и СВАКИ објекат у њему уништавају се неповратно. Унесите име poola за потврду.',
        confirmLabel: 'Име poola',
        confirmHint: 'Унесите име poola за потврду',
        deleteError: 'Брисање poola је одбијено',
        detailTitle: 'Детаљи poola',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Укључен',
        autoscalerOff: 'Искључен',
        autoscalerWarn: 'Обавести',
        pgNumLabel: 'Број PG-ова',
        pgNumCaption: 'Посматрано: autoscaler га може променити сам од себе — ово поље уписује жељу.',
        storage: 'Придружени TVirt storage',
        addAsStorage: 'Додај као TVirt storage',
        ruleSudoHint: 'Промена CRUSH правила захтева лозинку оператера.',
        updateError: 'Измена poola је одбијена',
        updated: 'Измена poola покренута — осматрање се само ажурира'
      },
      crush: {
        section: 'CRUSH правила',
        notObserved: 'Још нема CRUSH осматрања — mon sweep извештава овде',
        empty: 'Ниједно правило није посматрано на кластеру',
        hint: 'Правило одлучује ГДЕ завршавају копије сваког објекта — његов домен отказа је јединица која може да откаже без губитка података. Poolovi показују на правило; builtin replicated_rule (једна реплика по серверу) је подразумевано правило од рођења.',
        create: 'Креирај правило',
        createGuard: 'CRUSH правила постоје само на deployovanom кластеру',
        createTitle: 'Креирајте CRUSH правило',
        createHint: 'Једно правило = један избор домена отказа. Правило се рађа репликовано на подразумеваном rootu — посао обавља задатак на MON чвору; poolove придружите накнадно из таба Poolovi.',
        createError: 'Креирање правила је одбијено',
        name: 'Име правила',
        nameHint: 'DNS-safe (мала слова, цифре, цртице).',
        domain: 'Домен отказа',
        domainChoice: {
          osd: 'Свака реплика на различитом OSD-у',
          host: 'Свака реплика на различитом серверу',
          rack: 'Свака реплика у различитом racku'
        },
        domainCustom: 'Прилагођено (ручно написани степови)',
        domainOther: 'Свака реплика у различитом bucketu типа {type}',
        rackGuardHint: 'Ниједан rack bucket не постоји у посматраној хијерархији: правило се свакако може креирати, али ниједан pool не може да покаже на њега док rack не буде декларисан у размештају чланских сервера (подешавања чвора) — задатак поравнања гради bucket и придруживање се отвара само од себе.',
        treeTitle: 'Посматрана хијерархија',
        treeNotObserved: 'Још нема осматрања хијерархије — mon sweep извештава овде',
        treeOsds: 'OSD-ова: {n}',
        treeHint: 'CRUSH мапа онако како је кластер види: root → декларисани нивои → сервери (хостови) → OSD-ови. Топологија прати декларисани размештај сваког сервера (подешавања чвора) — промена размештаја је поново поравнава кроз задатак.',
        unplacedWarning: 'Чланови без декларисаног размештаја: {nodes} — њихови хостови остају директно испод roota, изван декларисане топологије. Декларишите позицију у подешавањима чвора (упозорење, никада блокада).',
        colName: 'Име',
        colDomain: 'Домен отказа',
        colPools: 'Poolovi',
        builtinChip: 'builtin',
        builtinGuard: 'Подразумевано правило кластера — платформа га никада не брише',
        detailAction: 'Детаљ правила',
        detailType: 'Тип',
        backToRules: 'Правила',
        ruleNotObserved: 'Посматрана листа правила не именује ово правило',
        noPools: 'Ниједан pool не користи ово правило',
        delete: 'Обриши правило',
        deleteTitle: 'Обришите CRUSH правило',
        deleteBody: 'Правило {rule} уклања се из crushmapa кластера. Ниједан pool не сме да га користи. Унесите име правила за потврду.',
        deleteGuard: 'Користи га pool {name} — прво преусмерите pool',
        confirmLabel: 'Име правила',
        confirmHint: 'Унесите име правила за потврду',
        deleteError: 'Брисање правила је одбијено',
        changeRule: 'Промени CRUSH правило',
        changeRuleTitle: 'Промените CRUSH правило',
        changeRuleHint: 'Pool почиње да распоређује своје објекте по изабраном правилу — Ceph премешта постојеће податке ради усклађивања (на пуном poolu следи ребаланс).',
        changeRuleError: 'Промена правила је одбијена',
        rule: 'CRUSH правило',
        rawTitle: 'Сирови crushmap (декомпајлиран)',
        rawWarning: 'ОПАСНОСТ: овај текст је ЦЕЛОКУПНА политика размештаја кластера. Погрешна мапа може одједном да сломи placement свих poolova. Чување компајлира и тестира мапу crushtoolom ПРЕ убацивања — али и валидна мапа свеједно може бити лоша идеја.',
        rawReload: 'Поново учитај',
        rawLoading: 'Query у току — read-only задатак декомпајлира crushmap…',
        rawSave: 'Сачувај crushmap',
        rawSaveTitle: 'Убаците crushmap',
        rawSaveBody: 'Измењени текст замењује crushmap ЦЕЛОГ кластера после crushtool compile + тест. Унесите име кластера за потврду.',
        rawConfirmLabel: 'Име кластера',
        rawConfirmHint: 'Унесите {name} за потврду',
        rawError: 'Операција над crushmapom није успела',
        rawHint: 'Текст је у crushtool -d облику. Грешке компајлирања и падови теста враћају се дословно из crushtoola — мапа никада не стиже до кластера ако било која од две капије падне.'
      },
      objects: {
        poolsSection: 'Истраживач објеката',
        poolsHint: 'Изаберите pool да излистате његове RBD слике. Свако дубоко читање ради као read-only задатак на MON чвору — никада не блокира стварне операције (нити га оне блокирају).',
        deployedGuard: 'Query над објектима одговарају само на deployovanom кластеру',
        browse: 'Прегледај објекте',
        detailAction: 'Детаљ слике',
        backToPools: 'Poolovi',
        backToImages: 'Слике',
        refresh: 'Освежи',
        loading: 'Query у току — read-only задатак испитује кластер…',
        error: 'Query није успео',
        retry: 'Покушај поново',
        notRbd: 'Pool са application „{app}“ — не садржи RBD слике, овде нема шта да се истражује',
        noImages: 'Ниједна RBD слика у овом poolu',
        colImage: 'Слика',
        colSize: 'Величина',
        colObjects: 'Објекти',
        colSnapshots: 'Снимци',
        imagesHint: 'Дискови на конзумирајућем rbd storageu су слике назване по ид-у свог диска. Број објеката је provisioned (величина / величина објекта) — стварна употреба живи у детаљу слике.',
        infoTitle: 'Слика',
        infoSize: 'Виртуелна величина',
        infoObjects: 'Објекти (provisioned)',
        infoObjectSize: 'Величина објекта',
        infoPrefix: 'Префикс објеката',
        infoFormat: 'Формат',
        infoFeatures: 'Feature',
        usageTitle: 'Стварна употреба (rbd du)',
        usageOf: 'од {provisioned} GiB provisioned',
        usageHint: 'Thin по природи: само уписани објекти заузимају бајтове.',
        watchersTitle: 'Watcheri',
        noWatchers: 'Ниједан watcher — нико тренутно нема ову слику отворену',
        snapshotsTitle: 'RBD снимци',
        noSnapshots: 'Ниједан RBD снимак на овој слици',
        colSnapshot: 'Снимак',
        colProtected: 'Заштићен',
        colTimestamp: 'Креиран',
        protected: 'заштићен',
        mappingTitle: 'Физички размештај (OSD скуп)',
        mappingSampled: 'Узорковани објекти: {sampled} од {total} — поштен резиме: за велике слике скуп конвергира ка СВИМ OSD-овима poola (CRUSH распоређује објекте по целом poolu).',
        mappingComplete: 'Сви објекти мапирани ({total} од {total}).',
        objectQueryTitle: 'Мапирајте појединачни објекат',
        objectName: 'Име објекта',
        objectHint: 'Имена RADOS објеката су <prefiks>.<16-hex indeks> — ceph osd map одговара PG-ом и OSD скуповима.',
        mapObject: 'Мапирај',
        primary: 'примарни: osd.{osd}'
      },
      registerDevice: {
        title: 'Региструјте OSD уређај',
        hint: 'На живом кластеру регистрација и ПРИПРЕМА уређај: постаје BlueStore OSD кроз аутоматски задатак везан за чвор (никада празан, ратификовано 2026-07-24). Уређај припада највише једном Ceph кластеру у целој флоти.',
        disk: 'Диск за податке',
        diskHint: 'Декларисани дискови за податке овог чвора — име и pin серијског броја',
        noDeclared: 'Ниједан диск за податке није декларисан на овом чвору — прво их означите у локалним подешавањима чвора',
        serialHint: 'Серијски број уређаја — pin идентитета',
        encrypted: 'Шифруј овај OSD (dmcrypt)',
        encryptedHint: 'Избор по OSD-у (режим кластера је „избор по сваком OSD-у“): замрзава се на овом диску при регистрацији — каснија промена режима га никада не преписује; то ради акција реда шифруј/дешифруј.',
        error: 'Регистрација је одбијена'
      },
      unregisterDevice: {
        title: 'Дерегиструјте уређај',
        body: 'Само регистар: {name} престаје да буде OSD кандидат овог кластера. Његови бајтови се не дирају.',
        error: 'Дерегистрација је одбијена'
      },
      deploy: {
        action: 'Понови deploy',
        title: 'Поновите bootstrap',
        body: 'Bootstrap рођења креће поново од тренутне конфигурације: monovi се покрећу, сваки регистровани уређај се припрема и активира као BlueStore OSD. Операција ради као макрозадатак — фаза се сама ажурира.',
        started: 'Bootstrap покренут — наставља као макрозадатак; фаза се сама ажурира',
        error: 'Bootstrap је одбијен'
      },
      propose: {
        action: 'Предложи као storage',
        title: 'Предложите као storage',
        hintPool: 'Постојећи pool {name} постаје TVirt storage: cephx идентитет ограничен на pool слеће у keystore и ceph-rbd storage се рађа спреман. Предлог конзумира pool — никада га не креира.',
        hintFs: 'Постојећи filesystem {name} постаје TVirt storage: cephx идентитет ограничен на filesystem слеће у keystore и cephfs storage се рађа спреман и монтиран. Предлог конзумира filesystem — никада га не креира.',
        name: 'Име storagea',
        nameHint: 'DNS-1123, јединствено у scopeu — cephx идентитет добија име по њему.',
        path: 'Путања унутар filesystema',
        pathHint: 'Апсолутна путања унутар filesystema који storage монтира — / ако сте у недоумици.',
        alsoPropose: 'Предложи одмах као storage',
        alsoProposePoolHint: 'После креирања исти гест предлаже новорођени pool као ceph-rbd storage — два експлицитна позива, један дијалог.',
        alsoProposeFsHint: 'После креирања исти гест предлаже новорођени filesystem као cephfs storage — два експлицитна позива, један дијалог.',
        guard: 'Предложи као storage — само на healthy кластеру',
        started: 'Предлог прихваћен — storage се материјализује; наћи ћете га под Storage',
        submit: 'Креирај storage',
        error: 'Предлог је одбијен'
      },
      fs: {
        section: 'Filesystemi',
        create: 'Креирај filesystem',
        createGuard: 'Filesystemi постоје само на deployovanom кластеру',
        mdsFirstGuard: 'Прво додајте MDS — filesystem без metadata сервера рађа се неупотребљив',
        notObserved: 'Још нема осматрања filesystema — MON sweep извештава овде',
        empty: 'Ниједан filesystem на кластеру',
        colName: 'Име',
        colPools: 'Poolovi',
        colMds: 'MDS',
        noActiveMds: 'ниједан активан MDS',
        delete: 'Уклони filesystem',
        deleteGuard: 'Конзумира га storage {name} — прво обришите storage',
        hint: 'Filesystem поседује своје poolove за податке и метаподатке (cephfs.<ime>.data / .meta): рађају се с њим и умиру с њим — removeFs, никада ручно брисање poola. Ова табела је посматрана истина из MON sweepa.',
        createTitle: 'Креирајте filesystem',
        createHint: 'Filesystem се рађа на кластеру са своја два poola (application cephfs) и служе га декларисани MDS-ови — посао обавља задатак на MON чвору. Укључите „Предложи као storage“ да га одмах конзумирате истим гестом.',
        name: 'Име filesystema',
        nameHint: 'DNS-safe (мала слова, цифре, цртице).',
        sizeHint: 'Реплике ОБА новорођена poola. Подразумевано 3.',
        createError: 'Креирање filesystema је одбијено',
        deleteTitle: 'Уклоните filesystem',
        deleteBody: 'Filesystem {fs} и СВАКА датотека у њему уништавају се неповратно — његови poolovi за податке и метаподатке умиру с њим. Унесите име filesystema за потврду.',
        confirmLabel: 'Име filesystema',
        confirmHint: 'Унесите име filesystema за потврду',
        deleteError: 'Уклањање filesystema је одбијено'
      },
      destroy: {
        action: 'Уништи',
        retryAction: 'Понови уништавање',
        retryGuard: 'Уништавање је у току — поновни покушај важи за неуспело уништавање (lease га иначе одбија)',
        title: 'Уништите кластер',
        body: 'Deployovani fabric се руши: сваки демон овог кластера се зауставља, његово системско стање и кључеви у keystoreu се ослобађају. Кад уништавање успе, кластер се аутоматски уклања.',
        confirmLabel: 'Име кластера',
        confirmHint: 'Унесите име кластера за потврду',
        wipe: 'Обриши регистроване уређаје',
        wipeHint: 'Означено: потписи сваког регистрованог уређаја се бришу — подаци на њима су уништени. Неозначено: бајтови остају нетакнути и уређаји се враћају у регистроване.',
        guard: 'Уништи — ништа није deployovano',
        started: 'Уништавање покренуто — наставља као макрозадатак; фаза се сама ажурира',
        error: 'Уништавање је одбијено'
      },
      delete: {
        guard: 'Обриши — само конфигурација која није deployovana (прво уништите)',
        title: 'Обрисати {name}?',
        body: 'Конфигурација и њен регистар уређаја се уклањају. Легално само док ништа није deployovano.',
        error: 'Брисање је одбијено'
      }
    }
  }
}
